module.exports = __webpack_public_path__ + "img/expostyle_9395_taupe_pantone405c.6587f7d4.jpg";